import { render, staticRenderFns } from "./courseCatalogSetting.vue?vue&type=template&id=388a3438&scoped=true&"
import script from "./courseCatalogSetting.vue?vue&type=script&lang=js&"
export * from "./courseCatalogSetting.vue?vue&type=script&lang=js&"
import style0 from "./courseCatalogSetting.vue?vue&type=style&index=0&id=388a3438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a3438",
  null
  
)

export default component.exports